import { render, staticRenderFns } from "./ver-capacitaciones.vue?vue&type=template&id=1d6e57c0&"
import script from "./ver-capacitaciones.vue?vue&type=script&lang=js&"
export * from "./ver-capacitaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports